import React, { useMemo, useEffect, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { useNavigate } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  DeleteSiteSetting,
  FetchSiteSettings,
  UpdateSiteSetting,
} from "../../apis/SiteSettings";

const SiteSettings = () => {
  const [siteSettings, setSiteSettings] = useState([]);
  const [updateData, setUpdateData] = useState({
    siteSettingId: "",
    title: "",
    name: "",
    value: "",
  });
  const [deleteData, setDeleteData] = useState({
    siteSettingId: "",
  });
  const [modal_standard, setModal_standard] = useState(false);
  const [modal_static, setModal_static] = useState(false);

  const tog_standard = () => setModal_standard(!modal_standard);
  const tog_static = () => setModal_static(!modal_static);
  const navigate = useNavigate();

  const fetchSiteSettings = async () => {
    try {
      const response = await FetchSiteSettings();
      const filteredSettings = response.siteSettings.filter(
        (setting) => setting.type === "site_settings"
      );
      setSiteSettings(filteredSettings);
    } catch (error) {
      toast.error("Failed to fetch site settings");
    }
  };

  const handleUpdate = async () => {
    const { siteSettingId, title, name, value } = updateData;
    try {
      const updatedSiteSetting = await UpdateSiteSetting(
        siteSettingId,
        title,
        name,
        value
      );
      if (updatedSiteSetting) {
        toast.success("Site setting updated successfully");
        setModal_standard(false);
        fetchSiteSettings();
        navigate("/site-settings");
      }
    } catch (error) {
      toast.error("Site setting update failed");
    }
  };

  const handleDelete = async () => {
    const { siteSettingId } = deleteData;
    try {
      const response = await DeleteSiteSetting(siteSettingId);
      if (response) {
        toast.success("Site setting deleted successfully");
        setModal_static(false);
        fetchSiteSettings();
        navigate("/safety");
      }
    } catch (error) {
      toast.error("Site setting deletion failed");
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: " Name",
        accessor: "name",
      },

      {
        Header: " Value",
        accessor: "value",
      },

      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => new Date(value).toLocaleDateString(),
      },

      {
        Header: "Action",
        accessor: "actions",
        Cell: ({ row }) => (
          <div>
            <Button
              color="primary"
              className="btn-icon"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </Button>
            <Button
              color="danger"
              className="btn-icon"
              onClick={() => handleDeleteClick(row.original)}
            >
              <i className="mdi mdi-delete"></i>
            </Button>
          </div>
        ),
      },
    ],
    []
  );

  const handleEditClick = (siteSetting) => {
    setUpdateData({
      siteSettingId: siteSetting._id,
      title: siteSetting.title,
      name: siteSetting.name,
      value: siteSetting.value,
    });
    tog_standard(); // Open the modal
  };

  const handleDeleteClick = (siteSetting) => {
    setDeleteData({
      siteSettingId: siteSetting._id,
    });
    tog_static(); // Open the modal
  };

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Site settings", link: "#" },
  ];

  return (
    <React.Fragment>      <div className="page-content">
        <Container>
          <Breadcrumbs title="DATA TABLES" breadcrumbItems={breadcrumbItems} />
          <Card style={{ marginLeft: "150px" }}>
            <CardBody>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  color="success"
                  className="waves-effect waves-light me-1"
                  onClick={() => navigate("/site-settings/add")}
                >
                  Add Site Setting
                </Button>
              </div>
              <TableContainer
                columns={columns || []}
                data={siteSettings || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
              />
            </CardBody>
          </Card>

          {/* START: Modal EDIT  */}
          <Modal isOpen={modal_standard} toggle={tog_standard}>
            <ModalHeader toggle={() => setModal_standard(false)}>
              Modal Heading
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={handleUpdate}>
                <div className="mb-3">
                  <AvField
                    name="title"
                    label="Site setting Name"
                    placeholder="Type Something"
                    type="text"
                    errorMessage="Enter Name"
                    value={updateData.title}
                    validate={{ required: { value: true } }}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        title: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="name"
                    label="Site setting Name"
                    placeholder="Type Something"
                    type="text"
                    errorMessage="Enter Name"
                    value={updateData.name}
                    validate={{ required: { value: true } }}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        name: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="value"
                    label="Site setting Name"
                    placeholder="Type Something"
                    type="text"
                    errorMessage="Enter value"
                    value={updateData.name}
                    validate={{ required: { value: true } }}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              </AvForm>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={tog_standard}
                color="light"
                className="waves-effect"
              >
                Close
              </Button>
              <Button
                type="button"
                onClick={handleUpdate}
                color="primary"
                className="waves-effect waves-light"
              >
                Save Changes
              </Button>
            </ModalFooter>
          </Modal>
          {/* END: Modal EDIT  */}

          {/* START: Modal DELETE */}

          <Modal isOpen={modal_static} toggle={tog_static} backdrop="static">
            <ModalHeader toggle={() => setModal_static(false)}>
              Static Backdrop
            </ModalHeader>
            <ModalBody>
              <p>Are you sure you want to delete this space?</p>
              <ModalFooter>
                <Button type="button" color="light" onClick={tog_static}>
                  Close
                </Button>
                <Button type="button" color="primary" onClick={handleDelete}>
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </Modal>
          {/* END: Modal DELETE */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SiteSettings;
